import { createFileRoute } from "@tanstack/react-router";
import { EditEmail } from "../../pages/Auth/EditEmail";
import { requireAuth } from "../../utils/routeGuards";

export const Route = createFileRoute("/auth/edit-email")({
  beforeLoad: ({ location }) => requireAuth(location),
  component: EditEmail,
});
